import { Association } from '@/shared/dtos/association';
import { DxSelectBox, DxTextBox, DxValidator, DxValidationGroup } from 'devextreme-vue';
import { DxRequiredRule } from 'devextreme-vue/validator';
import { userModule } from '@/store';
import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import { User } from '../../../../shared/dtos/user';
import { ItiBaseModal, ItiToolbarOkCancel, ItiTextField, ItiCheckbox, ItiForm } from '@/iti-core-vuetify';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { itiMessageService, ItiString } from '@/iti-core-vue';
import cnaeCodeModule from '@/store/modules/cnae-code.module'
import asociationModule from '@/store/modules/association.module'
import DxDataGrid, { DxSelection, DxPaging, DxHeaderFilter, DxEditing, DxColumn, DxFilterRow, DxFilterPanel, DxExport, DxColumnChooser } from 'devextreme-vue/data-grid';
import { Rol } from '@/shared/dtos/rol';
import DxButton from 'devextreme-vue/button';
import DxValidationSummary from 'devextreme-vue/validation-summary';
import templatesModule from '@/store/modules/templates.module';

@Component({
    components: {
        ValidationObserver,
        ValidationProvider,
        ItiToolbarOkCancel,
        ItiTextField,
        ItiCheckbox,
        ItiForm,
        DxTextBox,
        DxSelectBox,
        DxValidator,
        DxRequiredRule,
        DxValidationGroup,
        DxDataGrid,
        DxSelection,
        DxPaging,
        DxHeaderFilter,
        DxEditing,
        DxColumn,
        DxFilterRow,
        DxFilterPanel,
        DxExport,
        DxColumnChooser,
        DxButton,
        DxValidationSummary
    },
})
export default class UserForm extends ItiBaseModal {

    @Prop() id !: number;
    private roleSelect: number | null = null;

    public async mounted() {
        if (!isNaN(this.id) && this.id != 0) {
            userModule.getUser(this.id).then(() => {
                userModule.getUserRoles();
                cnaeCodeModule.getCnaeCodes();
                asociationModule.getAssociations();
                userModule.getRoles();
                userModule.getNormalRoles();
                userModule.getAmbitRoles();
            });
        }
    }

    public get user() {
        return userModule.userSelect;
    }

    public get cnaeCodeList() {
        return cnaeCodeModule.cnaeCodes;
    }

    public get rolesList() {
        return userModule.roles;
    }

    public get normalRolesList(){
        return userModule.normalRoles;
    }

    public get rolesUser() {
        return userModule.userRoles;
    }

    public get columnsRoles() {
        return [
            { dataField: 'id' },
            { dataField: 'name' },
            { dataField: 'description' },
            {
                type: 'buttons',
                buttons:
                    [
                        {
                            hint: this.$tc('maestros.eliminar'),
                            icon: 'trash',
                            visible: true,
                            onClick: this.deleteUserRole,
                        },
                    ],
                width: '50px',
            }
        ]
    }

    public deleteUserRole(item: any) {
        const role = item.row.data;
        userModule.deleteUserRole(role);
    }

    public addUserRole() {
        if(this.roleSelect){
            userModule.addUserRole(this.roleSelect);
        }
        this.roleSelect = null;
    }

    public get associationList() {
        var associations: Association[] = [];
        var emptyAssociation = new Association();
        emptyAssociation.id = -1;
        associations.push(emptyAssociation);

        associations = associations.concat(asociationModule.associations);

        return associations;
    }

    public setNameRole(role: Rol) {
        if (role != null) {
            return this.$tc('enum-user-role.' + role.name);
        }
    }

    public saveUser() {        
        itiMessageService.confirm(this.$tc('mensajes-plantillas.pregunta-guardar'), this.$tc('mensajes.confirmar'), (res) => {
            if (res) {
                userModule.modificarUsuario(this.user)
                .then(async () => {
                    this.$router.push({ name: 'Users'});
                    itiMessageService.toast(this.$tc('mensajes-plantillas.ok'), 'success', 3000);
                })
                .catch(() => {
                    itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);
                });
            }
        });
    }

    public cancelUser() {
        itiMessageService.confirm(this.$tc('mensajes-plantillas.pregunta-salir'), this.$tc('mensajes.confirmar'), (res) => {
            if (res) {
                this.$router.push({ name: 'Users'});
            }
        });
    }
}
